import React, { useEffect,useState,useRef } from "react";
import { useDrag } from "../customHook/useDrag";
import { useSelector, useDispatch } from "react-redux";
import { addNote, changeXY, showPopup,showNotePreview, loadSaved ,setFOCMode} from "../states/noteState";
const getXY=(e)=>{
    var { left, top } = e.target.getBoundingClientRect()
    var left = (e.clientX - left) * (1 / Global.currentScale)
    var top = (e.clientY - top) * (1 / Global.currentScale)
    return { x: left, y: top }
}

const Note = ({props}) => {
    const dispatch = useDispatch();
    var { name, x, y, text,index } = props
    const noteState = useSelector(state => state.note)
    const draggableRef = useRef(null);
    const zIndex = _epubController.attributes.rendered_spine_items.length+1
    const { position,handleMouseDown,handleMouseUp,checkInitPos,setFinalPosition } = useDrag({
      ref: draggableRef,
    //   initPos:{x:x+80,y:y+80}, 
      parent: document.getElementById("crootHost"),
    //   shouldApply:noteState.focmode ?true : false,
    });
    const [notePreviewFlag , showPreview]= useState(false)
    useEffect(() => {
        if(noteState.notePreview !== null && noteState.focmode)
        {
            showPreview(true)
        }else
        { 
            showPreview(false)
        }
    }, [noteState.notePreview])
    useEffect(()=>{
        if(draggableRef?.current && notePreviewFlag)
        {
          const { current: draggableElement } = draggableRef;
          const dragEl = draggableElement.getBoundingClientRect()
          var [position,outside]=checkInitPos({clientX:dragEl.left||x,clientY:dragEl.top||y})
        
        outside ? 
        setFinalPosition(position):null 
        // setFinalPosition({x:dragEl.left,y:dragEl.top})
      }
      },[notePreviewFlag,noteState.notePreview])
      var textAreaCol=0, textAreaRow = text.split("\n")
        text.split("\n").forEach(i => {
            if(textAreaCol < i.length)
                textAreaCol = i.length
        })
        textAreaCol = textAreaCol > 30 ? 30 : textAreaCol < 7 ? 7 : textAreaCol
        textAreaRow = (text.length || 1)/textAreaCol // > 2 ?textAreaRow.length > 7 ? 7:textAreaRow.length : 2
        textAreaRow = textAreaRow < 2 ? 2:textAreaRow
    return <><div key={name}
                id={name}
                style={{ position: "absolute", zIndex:zIndex,top:y, left:x }}
                onMouseEnter={ ()=>dispatch(showNotePreview(name)) } >
        <button title ={`note ${index + 1}`} aria-label={`note ${index + 1}`} className={"opr-noteVisibleIcon"} name={name} style={noteState.notePreview == name ? {backgroundColor:"#254687"}:null}
                onClick={(e) => dispatch(showPopup({ popupShown: true, name: e.target.name }))}></button>
    </div>
    { noteState.focmode && noteState.notePreview == name ?
    <div name={name} ref={ draggableRef }
            onMouseDown={ noteState.focmode ? handleMouseDown:null} 
            onMouseUp={ noteState.focmode ? handleMouseUp:null} 
            style={{ position: "absolute", zIndex:zIndex+1,
                    top:position? position.y: y+80,
                    left:position?position.x :x,
                    display: notePreviewFlag && noteState.notePreview == name ? "flex" : "none"}}
            className={"opr-NotePreviewPopup"} >
        < button class="opr-all-icons close opr-NoteCloseIcon" onMouseMove={e=> e.stopPropagation()} onClick={(e)=> dispatch(showNotePreview(null))} >  </button>
        <textarea id="noteText" name="noteText" rows={ textAreaRow } cols={textAreaCol} defaultValue={text} readOnly={true}/>
        </div>
        :null
        }
    </>
}

const StickyNote = () => {
    const currentState = useSelector((state) => state.current)
    const noteState = useSelector(state => state.note)
    const dispatch = useDispatch();
    const handleMouseUp = (e) => {
        var data = getXY(e)
        dispatch(changeXY(data))
    }
    useEffect(() => {
        dispatch(setFOCMode(currentState.focmode))
        var data = JSON.parse(localStorage.getItem(`notes#${Readium.userInfo.id}#${Readium.bookDetails.get('isbn')}#${$("#jumpToPageInput").val().split(" ").join("")}`))
        data && dispatch(loadSaved(data))
    }, [])
    // const [notesList, setNote] = useState([]);
    // const [noteFlag, enableNote] = useState(false)
    const enableNoteUi = () => {
        if (currentState && currentState.canvasObj != "") {
            currentState.canvasObj.containerEl.parentNode.classList.add("noteCursor");
            currentState.canvasObj.containerEl.classList.add("pointernone");
        }
    }
    const disableNoteUi = () => {
        if (currentState && currentState.canvasObj != "" && !currentState.focmode ) {
            currentState.canvasObj.containerEl.parentNode.classList.remove("noteCursor");
            currentState.canvasObj.containerEl.classList.remove("pointernone");
        }
    }
    useEffect(() => {
        if (currentState.canvasObj !== "" && currentState.canvasObj !== undefined && currentState.canvasObj !== null) {
            document.getElementById(currentState.canvasDiv).addEventListener("mouseup", handleMouseUp);
        }
    }, [currentState.canvasObj])
    useEffect(() => {
        noteState.newNote && dispatch(addNote())
    }, [noteState.newNote])
    useEffect(() => {
        if (noteState.noteFlag) {
            enableNoteUi()
        } else {
            disableNoteUi()
        }
    }, [noteState.noteFlag])
    useEffect(() => {
        if (noteState.lastNoteRef !== "") {
            disableNoteUi()
            dispatch(showPopup({ popupShown: true, name: noteState.lastNoteRef, newPopup: true }))
        }
    }, [noteState.lastNoteRef])
    return (
        <>
        {
         noteState.notesList.length ? noteState.notesList.map(({ name, x, y, text }, index)=><Note key={name} props={ {name, x, y, text,index} }></Note>): null    
        }
        </>
    );
}
export default StickyNote;